import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { toast } from '@grandvisionhq/common';
import { useLazyQuery } from '@grandvisionhq/graphql';
import { useIntl } from '@grandvisionhq/state';
import '../../operations/queries/get-place-by-id.js';
import { GET_STORES_BY_DISTANCE_WITH_INVENTORY } from '../../operations/queries/get-stores-by-distance.js';
import '../../operations/queries/get-store-by-code.js';
import '../../operations/queries/get-store-details.js';
import '../../operations/queries/get-nearest-stores.js';
import '../../operations/queries/get-preferred-store.js';
import '../../operations/queries/get-preferred-store-code.js';
import '../../operations/queries/stores-search.js';
import { mapStoresResult } from './adapters/mapStoresResult.js';
import '../../types.js';

const useStoresByDistanceWithInventory = (variables)=>{
    const { locale  } = useIntl();
    const [query, queryState] = useLazyQuery(GET_STORES_BY_DISTANCE_WITH_INVENTORY, {
        variables,
        context: {
            forwardHeaders: {
                'Accept-Language': locale
            }
        },
        errorPolicy: 'all',
        fetchPolicy: 'no-cache',
        onError (error) {
            toast.failed('stores.page.search.getStoresByDistance.error');
            console.error('Failed to fetch store by distance: ', error);
        }
    });
    var _data;
    const { storesByDistance  } = (_data = queryState.data) !== null && _data !== void 0 ? _data : {};
    const data = React.useMemo(()=>mapStoresResult(storesByDistance)
    , [
        storesByDistance
    ]);
    return React.useMemo(()=>[
            query,
            swcHelpers.objectSpread({}, queryState, {
                data
            })
        ]
    , [
        data,
        queryState,
        query
    ]);
};

export { useStoresByDistanceWithInventory as default };
//# sourceMappingURL=use-stores-by-distance-with-inventory.js.map
